<app-pias-layout>
  <div pias-layout-content>
    @if(this.setSprinner()) {
    <div class="pias-spinner">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    }

    <div class="page-header-section">

      <!-- Left Content -->
      <div class="page-header-left">

        <div class="header-icon-badge">
          <mat-icon>manage_accounts</mat-icon>
        </div>

        <div class="title-wrapper">
          <h4 class="page-header">
            Adviser Maintenance
          </h4>
          <!-- <p class="page-subtitle">
            Track representative status across in-force, serving-notice and resigned agents.
          </p> -->
        </div>
      </div>

      <!-- Right Actions -->
      <div class="page-header-right">
        <!-- Carries the headline total previously held by the Total stat card. -->
        <!-- <span class="page-status-chip">
          <mat-icon>group</mat-icon>
          {{ totalCount }} Representatives
        </span> -->
        <button type="button" class="export-btn" (click)="openExportDialog()">
          <mat-icon>download</mat-icon>
          Export
        </button>
      </div>

    </div>

    <!-- Status filter tiles. Each is a toggle: clicking the selected one clears
         the filter, which is how "show all" survives the Total card's removal. -->
    <div class="container-fluid px-0">
      <div class="row g-3">

        <div class="col-12 col-sm-6 col-lg-3">
          <button type="button" class="stat-card inforce" [class.active]="selectedStatus === 'Inforced'"
            [attr.aria-pressed]="selectedStatus === 'Inforced'" (click)="clickFilters('Inforced')"
            matTooltip="Inforce — {{ inforceCount }} of {{ totalCount }} ({{ pctOf(inforceCount) }}). Click to filter.">
            <span class="stat-gauge" [style.background]="ringGradient(inforceCount)">
              <span class="stat-icon-wrap">
                <mat-icon>work</mat-icon>
              </span>
            </span>
            <span class="stat-info">
              <span class="stat-label">Inforce</span>
              <span class="stat-value">{{ inforceCount }}</span>
            </span>
            <mat-icon class="stat-check">check_circle</mat-icon>
          </button>
        </div>

        <!-- Off-boarding is a stage, not a status — this tile toggles its own
             filter and stacks with whatever status is selected. -->
        <div class="col-12 col-sm-6 col-lg-3">
          <button type="button" class="stat-card offboarding" [class.active]="selectedStatus === 'Offboarding'"
            [attr.aria-pressed]="selectedStatus === 'Offboarding'" (click)="clickFilters('Offboarding')"
            matTooltip="Off-boarding initiated — {{ offboardingCount }} of {{ totalCount }} ({{ pctOf(offboardingCount) }}). Triggered while in force and stays through serving notice. Click to filter.">
            <span class="stat-gauge" [style.background]="ringGradient(offboardingCount)">
              <span class="stat-icon-wrap">
                <mat-icon>logout</mat-icon>
              </span>
            </span>
            <span class="stat-info">
              <span class="stat-label">Off-boarding</span>
              <span class="stat-value">{{ offboardingCount }}</span>
            </span>
            <mat-icon class="stat-check">check_circle</mat-icon>
          </button>
        </div>

        <div class="col-12 col-sm-6 col-lg-3">
          <button type="button" class="stat-card notice" [class.active]="selectedStatus === 'Serving Notice'"
            [attr.aria-pressed]="selectedStatus === 'Serving Notice'" (click)="clickFilters('Serving Notice')"
            matTooltip="Serving Notice — {{ servingListCount }} of {{ totalCount }} ({{ pctOf(servingListCount) }}). Click to filter.">
            <span class="stat-gauge" [style.background]="ringGradient(servingListCount)">
              <span class="stat-icon-wrap">
                <mat-icon>pending_actions</mat-icon>
              </span>
            </span>
            <span class="stat-info">
              <span class="stat-label">Serving Notice</span>
              <span class="stat-value">{{ servingListCount }}</span>
            </span>
            <mat-icon class="stat-check">check_circle</mat-icon>
          </button>
        </div>



        <div class="col-12 col-sm-6 col-lg-3">
          <button type="button" class="stat-card resigned" [class.active]="selectedStatus === 'Resigned'"
            [attr.aria-pressed]="selectedStatus === 'Resigned'" (click)="clickFilters('Resigned')"
            matTooltip="Resigned — {{ resignedCount }} of {{ totalCount }} ({{ pctOf(resignedCount) }}). Click to filter.">
            <span class="stat-gauge" [style.background]="ringGradient(resignedCount)">
              <span class="stat-icon-wrap">
                <mat-icon>person_remove</mat-icon>
              </span>
            </span>
            <span class="stat-info">
              <span class="stat-label">Resigned</span>
              <span class="stat-value">{{ resignedCount }}</span>
            </span>
            <mat-icon class="stat-check">check_circle</mat-icon>
          </button>
        </div>

      </div>
    </div>

    <div class="dashboard-main">
      <mat-card class="table-card">
        <!-- Search Section -->
        <div class="search-section">
          <div class="table-toolbar">
            <div id="recipient-filter-form" class="w-100">
              <form class="row align-items-center g-3">
                <!-- Search Input -->
                <div class="col-sm-12 col-md-6 col-lg-5 col-xxl-5 m-0">
                  <div class="position-relative" style="max-width: 500px">
                    <input #searchInput type="text" class="form-control search-input pe-10"
                      placeholder="Search by name or branch" aria-label="Search representatives"
                      (keyup)="_onSearchRecipients($event)" />

                    <!-- Search icon -->
                    <i class="fas fa-search position-absolute top-50 start-0 ms-3 translate-middle-y"
                      style="color: #888888"></i>

                    <!-- Clear button -->
                    <button *ngIf="searchInput.value" type="button"
                      class="btn position-absolute top-50 end-0 translate-middle-y me-1 p-3 border-0 bg-transparent"
                      style="z-index: 100; cursor: pointer" (click)="searchInput.value = ''; _clearRecipientSearch()">
                      <i class="fas fa-times" style="color: #888888; pointer-events: none"></i>
                    </button>
                  </div>
                </div>

                <!-- Contextual date filters — shown whenever Inforce or Resigned is the
                     selected status, whether picked from a tile or the All Status
                     dropdown. Serving Notice has no date field. These sit in the row's
                     spare columns, so the search and status controls keep their
                     positions. -->
                @if (dateFilterFor === 'Inforced') {
                <div class="col-sm-12 col-md-6 col-lg-7 col-xxl-6 m-0 date-filter-group">
                  <span class="date-filter-label">RNF Date</span>

                  <!-- Plain .form-control inputs so these match the search field; the
                       datepicker directive does not need a mat-form-field wrapper. -->
                  <div class="position-relative date-control">
                    <input type="text" class="form-control date-input" name="appointmentFrom"
                      [matDatepicker]="appointedFromPicker" [(ngModel)]="appointmentFrom" [max]="appointmentTo"
                      (dateChange)="applyFilters()" placeholder="From" aria-label="Appointed from" />
                    <mat-datepicker-toggle class="date-toggle" [for]="appointedFromPicker"></mat-datepicker-toggle>
                    <mat-datepicker #appointedFromPicker></mat-datepicker>
                  </div>

                  <div class="position-relative date-control">
                    <input type="text" class="form-control date-input" name="appointmentTo"
                      [matDatepicker]="appointedToPicker" [(ngModel)]="appointmentTo" [min]="appointmentFrom"
                      (dateChange)="applyFilters()" placeholder="To" aria-label="Appointed to" />
                    <mat-datepicker-toggle class="date-toggle" [for]="appointedToPicker"></mat-datepicker-toggle>
                    <mat-datepicker #appointedToPicker></mat-datepicker>
                  </div>

                  @if (hasDateFilter) {
                  <button type="button" class="date-clear-btn" (click)="clearDateFilters()"
                    matTooltip="Clear date filter" aria-label="Clear date filter">
                    <mat-icon>close</mat-icon>
                  </button>
                  }
                </div>
                }

                @if (dateFilterFor === 'Resigned') {
                <div class="col-sm-12 col-md-6 col-lg-7 col-xxl-6 m-0 date-filter-group">
                  <span class="date-filter-label">Resigned Date</span>

                  <div class="position-relative date-control">
                    <input type="text" class="form-control date-input" name="terminationFrom"
                      [matDatepicker]="terminationFromPicker" [(ngModel)]="terminationFrom" [max]="terminationTo"
                      (dateChange)="applyFilters()" placeholder="From" aria-label="Terminated from" />
                    <mat-datepicker-toggle class="date-toggle" [for]="terminationFromPicker"></mat-datepicker-toggle>
                    <mat-datepicker #terminationFromPicker></mat-datepicker>
                  </div>

                  <div class="position-relative date-control">
                    <input type="text" class="form-control date-input" name="terminationTo"
                      [matDatepicker]="terminationToPicker" [(ngModel)]="terminationTo" [min]="terminationFrom"
                      (dateChange)="applyFilters()" placeholder="To" aria-label="Terminated to" />
                    <mat-datepicker-toggle class="date-toggle" [for]="terminationToPicker"></mat-datepicker-toggle>
                    <mat-datepicker #terminationToPicker></mat-datepicker>
                  </div>

                  @if (hasDateFilter) {
                  <button type="button" class="date-clear-btn" (click)="clearDateFilters()"
                    matTooltip="Clear date filter" aria-label="Clear date filter">
                    <mat-icon>close</mat-icon>
                  </button>
                  }
                </div>
                }
              </form>

              <div class="col-sm-12 col-md-3 col-lg-2 col-xxl-2 m-0">
                <mat-form-field class="status-field" subscriptSizing="dynamic">
                  <mat-select name="selectedStatus" [(ngModel)]="selectedStatus"
                    (selectionChange)="onStatusFilterChange()">
                    <mat-option value="">ALL STATUS</mat-option>
                    <mat-option value="Inforced">INFORCE</mat-option>
                    <mat-option value="Offboarding">OFF-BOARDING</mat-option>
                    <mat-option value="Serving Notice">SERVING NOTICE</mat-option>
                    <mat-option value="Resigned">RESIGNED</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>

            <!-- <div class="results-count">
              {{ contactsDs.data.length }} of {{ totalCount }} results
            </div> -->
          </div>

        </div>
        <mat-card-content>
          <!-- Data Table -->
          <div class="table-wrapper">
            <table mat-table [dataSource]="contactsDs" class="applicants-table"
            matSort matSortDisableClear  matSortDirection="desc" #sort="matSort">
              <ng-container matColumnDef="repcode">
                <th mat-header-cell *matHeaderCellDef mat-sort-header >Rep Code</th>
                <td mat-cell *matCellDef="let applicant">{{ applicant.repcode }}</td>
              </ng-container>
              <ng-container matColumnDef="repname">
                <th mat-header-cell *matHeaderCellDef mat-sort-header >Rep Name</th>
                <td mat-cell *matCellDef="let applicant">
                  <div class="rep-name-cell">
                    <!-- <span class="avatar-circle"
                    [style.background-color]="getAvatarStyle(applicant.fullName).bg"
                    [style.color]="getAvatarStyle(applicant.fullName).color">
                    {{ getInitials(applicant.fullName) }}
                  </span> -->
                    <span>{{ applicant.repname }}</span>
                  </div>
                </td>
              </ng-container>

              <ng-container matColumnDef="preferredname">
                <th mat-header-cell *matHeaderCellDef mat-sort-header >Preferred Name</th>
                <td mat-cell *matCellDef="let applicant">{{ applicant.preferredname }}</td>
              </ng-container>

              <!-- Branch Column -->
              <ng-container matColumnDef="branch">
                <th mat-header-cell *matHeaderCellDef mat-sort-header >Branch</th>
                <td mat-cell *matCellDef="let applicant">
                  {{ applicant.branch }}
                </td>
              </ng-container>

              <!-- Rnf Date Column -->
              <ng-container matColumnDef="rnfDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header >RNF Date</th>
                <td mat-cell *matCellDef="let applicant">
                  @if(applicant.rnfDate.startsWith('1900-01-01')){
                  -
                  }@else{
                  {{ applicant.rnfDate | date: 'dd MMM yyyy' }}
                  }
                </td>
              </ng-container>

              <!-- Resinged Date  Column -->
              <ng-container matColumnDef="dateResigned">
                <th mat-header-cell *matHeaderCellDef mat-sort-header >Resigned Date</th>
                <td mat-cell *matCellDef="let applicant">
                  @if(applicant.dateResigned.startsWith('1900-01-01')){
                  -
                  }@else{
                  {{ applicant.dateResigned | date: 'dd MMM yyyy'}}
                  }
                </td>
              </ng-container>

              <!-- Status Column -->
              <ng-container matColumnDef="repstatus">
                <th mat-header-cell *matHeaderCellDef mat-sort-header > Rep Status</th>
                <td mat-cell *matCellDef="let applicant">
                  <span [ngClass]="'status-chip ' + getStatusClass(applicant.repstatus)">
                    @if(applicant.repstatus == 'Inforced'){
                    INFORCE
                    }@else if(applicant.repstatus == 'Serving Notice'){
                    SERVING NOTICE
                    }@else{
                    RESIGNED
                    }
                  </span>
                </td>
              </ng-container>

              <!-- Actions Column — also carries the off-boarding badge, a stage
                 indicator rather than a status: it is triggered while the rep is
                 in force and stays set through serving notice. -->
              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>Actions</th>
                <td mat-cell *matCellDef="let applicant">
                  <div class="row-actions">

                    <button mat-icon-button matTooltip="View" (click)="goToView(applicant)"
                      class="action-icon-btn view-btn">
                      <mat-icon>visibility</mat-icon>
                    </button>


                    <span class="edit-icon-slot">
                      @if(['Inforced','Serving Notice'].includes(applicant.repstatus)){
                      <button mat-icon-button matTooltip="Edit" (click)="goToEdit(applicant)"
                        class="action-icon-btn edit-btn">
                        <mat-icon>edit</mat-icon>
                      </button>
                      }
                    </span>
                    @if(['Inforced','Serving Notice'].includes(applicant.repstatus)){
                    @if(applicant.status == 'offboarding_completed'){
                       <span class="offboarding-flag" matTooltip="Off-boarding Completed">
                       <mat-icon>logout</mat-icon>
                        Off-boarded
                       </span>
                    }@else{
                      @if (applicant.isOffboarded) {
                      <span class="offboarding-flag" matTooltip="Off-boarding initiated — resignation in progress">
                      <mat-icon>logout</mat-icon>
                      Off-boarding
                      </span>
                      }                      
                    }
                    }

                  </div>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns" class="table-row"></tr>

              <!-- No Data Row -->
              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell no-data-cell" [attr.colspan]="displayedColumns.length">
                  <div class="empty-state">
                    <mat-icon>search_off</mat-icon>
                    <p>No representatives found</p>
                    <span>Try adjusting your search or status filter.</span>
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </mat-card-content>

        <!-- Paginator -->
        <div class="paginator-wrapper">
          <mat-paginator #paginator [pageSizeOptions]="[5, 10, 25, 50]" [pageSize]="5" showFirstLastButtons
            aria-label="Select page of recipients"></mat-paginator>
        </div>
      </mat-card>
    </div>
  </div>
</app-pias-layout>